module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style-guide"
  }, [_c('div', {
    staticClass: "style-guide__container"
  }, [_c('Icon', {
    staticClass: "style-guide__logo",
    attrs: {
      "name": "matt_logo-01"
    }
  }), _c('div', {
    staticClass: "style-guide__typography"
  }, [_c('h1', [_vm._v("Header 1")]), _c('h1', {
    staticClass: "h1-option"
  }, [_vm._v("Header 1.b")]), _c('h2', [_vm._v("Header 2")]), _c('h2', {
    staticClass: "h2-option",
    staticStyle: {
      "background": "black",
      "display": "inline-block"
    }
  }, [_vm._v("Header 2.b")]), _c('h3', [_vm._v("Header 3")]), _c('h3', {
    staticClass: "h3-option"
  }, [_vm._v("Header 3.b")]), _c('br'), _c('p', [_vm._v("This is paragraph text. It is the text style that is in paragraphs ")]), _c('p', [_vm._v("and is all throughout the page in paragraphs.")]), _c('br'), _c('div', {
    staticClass: "style-guide__icon-row"
  }, [_c('Icon', {
    staticClass: "style-guide__envelope",
    attrs: {
      "name": "envelope"
    }
  }), _c('Icon', {
    staticClass: "style-guide__fb",
    attrs: {
      "name": "fb"
    }
  }), _c('Icon', {
    staticClass: "style-guide__goog",
    attrs: {
      "name": "goog"
    }
  }), _c('Icon', {
    staticClass: "style-guide__phone",
    attrs: {
      "name": "phone"
    }
  }), _c('Icon', {
    staticClass: "style-guide__ig",
    attrs: {
      "name": "ig"
    }
  })], 1), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "style-guide__button-main"
  }, [_c('span', [_vm._v("Make an Appointment")]), _c('Icon', {
    staticClass: "style-guide__button-main-icon",
    attrs: {
      "name": "arrow"
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "style-guide__row"
  }, [_c('div', {
    staticClass: "style-guide__menu-container"
  }, [_c('div', {
    staticClass: "style-guide__menu"
  }, [_vm._v("MENU")]), _c('div', {
    staticClass: "style-guide__hamburger",
    class: {
      "style-guide__hamburger--active": _vm.active
    },
    on: {
      "click": function($event) {
        _vm.active = !_vm.active
      }
    }
  }, [_c('span'), _c('span')])]), _c('div', {
    staticClass: "style-guide__icons"
  }, [_c('div', {
    staticClass: "style-guide__icon-outer"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper smile",
    attrs: {
      "name": "smile"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer disabled"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner disabled"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper",
    attrs: {
      "name": "community"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer active"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper",
    attrs: {
      "name": "graduation"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper kite",
    attrs: {
      "name": "kite"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper",
    attrs: {
      "name": "party"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper ribbon",
    attrs: {
      "name": "ribbon"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper",
    attrs: {
      "name": "technology"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper",
    attrs: {
      "name": "bowtie"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper",
    attrs: {
      "name": "couch-plant"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper star",
    attrs: {
      "name": "star"
    }
  })], 1)]), _c('div', {
    staticClass: "style-guide__icon-outer"
  }, [_c('div', {
    staticClass: "style-guide__icon-inner"
  }, [_c('Icon', {
    staticClass: "style-guide__icon-wrapper",
    attrs: {
      "name": "shield"
    }
  })], 1)])])])])], 1), _c('div', {
    staticClass: "style-guide__content-wrapper"
  }, [_c('div', {
    staticClass: "style-guide__shape",
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  }), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style-guide__text-container"
  }, [_c('div', {
    staticClass: "style-guide__text"
  }, [_c('h2', [_vm._v("Why Not")])]), _c('div', {
    staticClass: "style-guide__right-container"
  }, [_c('div', {
    staticClass: "item"
  }), _c('div', {
    staticClass: "item"
  }), _c('div', {
    staticClass: "item"
  }), _c('div', {
    staticClass: "item"
  }), _c('div', {
    staticClass: "item"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3962ef0f","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/style-guide/style-guide.pug
// module id = 696
// module chunks = 1